<template>
    
    <tablecustom 
        @search="searchB" 
        :columns="columns" 
        :rows="filteredItems" 
        :objParams="objParams"
        @open="open"
    />

    <viewBonus 
        v-if="showModal"
        @close="showModal = false"
        :obj="objCard"
    />

</template>

<script>
import tablecustom from '@/components/globaltable/index';
import viewBonus from './view'
import { Dashboard } from '@/API_Dash'

let apiServe = new Dashboard();

export default{
    props: ['obj', 'companyId'],
    components: {
        tablecustom,
        viewBonus
    },
    data(){
        return{
            form: '',
            objCard: '',
            showModal: false,
            objParams: {
                search: ''
            },
            rows: '',
            columns: [
                {
                    name: "ID",
                    text: "bonusId",
                    align: "left",
                    status: true,
                    copy: true,
                },
                {
                    name: this.$t("Name"),
                    text: "bonusTitle",
                    align: "left",
                    status: true,
                    copy: true
                },
            ],
        }
    },
    created(){
        this.getdata();
    },
    methods: {
        getdata(){
            this.rows = this.obj
        },
        open(e){
            apiServe.getBonus(this.companyId, e.bonusId).then(result => {
                if(result.status == 'done'){
                    this.objCard = result.data;
                    this.showModal = true;
                } else if(result.status == 'error' && result.error[0] == 'empty company url'){
                    this.$toast.error(this.$t('emptyCompanyUrl'));
                } else {
                    this.$toast.error(this.$t('bonusNotFound'))
                }
            })
        },
        searchB(e){
            this.objParams.search = e
        },
    },
    computed: {
        filteredItems: function() {
            return this.rows
                // по пошуку
                .filter(item => {
                    return this.objParams.search == '' || item.bonusTitle.toString().toLowerCase().indexOf(this.objParams.search.toLowerCase()) !== -1;
                })
        },
    }
}
</script>